import ListingDetail from './ListingDetail'

export default ListingDetail
